import type { FaceDetection } from 'ff-face-detection';
import { boundingBoxOf } from '../boundingBoxOf';
import { Area } from '../types/Area';
import { Size } from '../types/Size';
import { clamp } from '../vector2d';

export const shiftCropToFaceCentered = (cropBox: Area, detections: FaceDetection[], imageSize: Size) => {

    if (detections.length < 1) {
        return cropBox;
    }

    const faceArea = boundingBoxOf(detections);

    if (!faceArea) {
        return cropBox;
    }

    const faceAreaCenter = {
        x: faceArea.x + 0.5 * faceArea.width,
        y: faceArea.y + 0.5 * faceArea.height
    };

    const proposedCropStart = {
        x: faceAreaCenter.x - 0.5 * cropBox.width,
        y: faceAreaCenter.y - 0.5 * cropBox.height
    };

    const minStart = {
        x: 0,
        y: 0
    };

    const maxStart = {
        x: imageSize.width - cropBox.width,
        y: imageSize.height - cropBox.height
    };

    const adjustedCropStart  = clamp(proposedCropStart , minStart, maxStart);

    return {
        x: adjustedCropStart.x,
        y: adjustedCropStart.y,
        width: cropBox.width,
        height: cropBox.height
    };
};